module.exports = __webpack_public_path__ + "img/about-bg3-en.e6bc01a2.png";